import {
  ContentVisibilitySlicerId,
  ContentTypeSlicerId,
  ContentSortDropdownId,
  CSVDownloadId,
  AddSuggestedReviewerId,
} from './RUMElementId';
import { getCssLocator } from './RUMElementId';
import {
  homePageFilterIncludeCode,
  homePageFilterTechDomain,
  homePageFilterRType,
  homePageFilterWorkload,
  homePageFilterAWSServices,
  homePageFilterEnv,
} from './RUMElementId';

const homePageContentTypeSlicerButton = [
  { event: 'click', cssLocator: getCssLocator('id', ContentTypeSlicerId.Strategy) },
  { event: 'click', cssLocator: getCssLocator('id', ContentTypeSlicerId.Guide) },
  { event: 'click', cssLocator: getCssLocator('id', ContentTypeSlicerId.Pattern) },
];

const homePageVisibilitySlicerButton = [
  { event: 'click', cssLocator: getCssLocator('id', ContentVisibilitySlicerId.Internal) },
  { event: 'click', cssLocator: getCssLocator('id', ContentVisibilitySlicerId.External) },
  { event: 'click', cssLocator: getCssLocator('id', ContentVisibilitySlicerId.Public) },
];

const homePageSortDropdownItems = [
  { event: 'click', cssLocator: getCssLocator('id', ContentSortDropdownId.NewToOld) },
  { event: 'click', cssLocator: getCssLocator('id', ContentSortDropdownId.OldToNew) },
  { event: 'click', cssLocator: getCssLocator('id', ContentSortDropdownId.AToZ) },
  { event: 'click', cssLocator: getCssLocator('id', ContentSortDropdownId.ZToA) },
];

const csvDownloadItems = [
  { event: 'click', cssLocator: getCssLocator('id', CSVDownloadId.Pattern) },
];

const addSuggestedReviewerItems = [
  { event: 'click', cssLocator: getCssLocator('id', AddSuggestedReviewerId.AddReviewer) },
];

const RUMDOMEvents = [
  ...homePageContentTypeSlicerButton,
  ...homePageVisibilitySlicerButton,
  ...homePageSortDropdownItems,
  ...homePageFilterIncludeCode,
  ...homePageFilterTechDomain,
  ...homePageFilterRType,
  ...homePageFilterWorkload,
  ...homePageFilterAWSServices,
  ...homePageFilterEnv,
  ...csvDownloadItems,
  ...addSuggestedReviewerItems,
];

export default RUMDOMEvents;
